/*global event, fdescribe*/
/*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/

export default () => {
	self.importScripts(self.origin + "/assets/js/CommonLayout.js");
	self.addEventListener(
		"message",
		event => {
			let args = event.data;
			self.postMessage(self.updateCurrentPage.apply(null, args));
		},
		false
	);

	self.updateCurrentPage = (
		layoutWidth,
		layoutTop,
		itemWidth,
		itemHeight,
		verticalMargin,
		itemsPerRow,
		containerZoom,
		itemsPerPage,
		totalPages,
		scrollTop
	) => {
		const calcVerticalMargin = self.CommonLayout.getVerticalMargin(
			layoutWidth,
			itemWidth,
			verticalMargin,
			itemsPerRow
		);
		const pageHeight = self.CommonLayout.getPageHeight(
			layoutWidth,
			itemWidth,
			itemHeight,
			verticalMargin,
			itemsPerRow,
			containerZoom,
			itemsPerPage
		);
		const calcScrollTop = Math.max(
			1,
			Math.min(
				totalPages,
				Math.ceil(
					(scrollTop + pageHeight * (0.1 / containerZoom)) /
						pageHeight
				)
			)
		);
		return calcScrollTop;
	};
};
